import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";
import useAxios from "../../../Utils/useAxios";
import getPredikatDetail from "../services/getPredikatDetail";
import { RekapSubkategoriKelompok } from "../constants/RekapSubkategoriList";
import getSkor from "../utils/rekap/getSkor";
import getSkorRentang from "../utils/rekap/getSkorRentang";

const RekapNilaiKelompok = ({ data, selectedAssessedBy }) => {
  const axiosInstance = useAxios();
  const [predikatDetail, setPredikatDetail] = useState([]);

  useEffect(() => {
    if (data.asesmen.length > 0) {
      for (let item of data.asesmen) {
        predikatDetails(item.predikats, item.assessed_by, item.unit_kerja);
      }
    }
  }, [data.asesmen]);

  const predikatDetails = (list, assessed_by, unit_kerja) => {
    getPredikatDetail(axiosInstance, list).then((res) => {
      setPredikatDetail((prev) => [
        ...prev,
        {
          assessed_by: assessed_by,
          unit_kerja: unit_kerja,
          data: res.data,
        },
      ]);
    });
  };

  const latestAssessments = data.asesmen.reduce((acc, curr) => {
    const existing = acc.find(
      (item) =>
        item.unit_kerja === curr.unit_kerja &&
        item.assessed_by === curr.assessed_by
    );
    if (!existing || existing.id < curr.id) {
      acc = acc.filter(
        (item) =>
          !(
            item.unit_kerja === curr.unit_kerja &&
            item.assessed_by === curr.assessed_by
          )
      );
      acc.push(curr);
    }
    return acc;
  }, []);

  // Get predikat details for the subkategori
  const getDataForSubkategori = (subkategoriIndex, assessed_by, unit_kerja) => {
    const recordUser = predikatDetail.find(
      (userData) =>
        userData.assessed_by === assessed_by &&
        userData.unit_kerja === unit_kerja
    );
    if (!recordUser) {
      return { predikat: "-", skorRentang: "-", koreksi: "-" };
    }
    const record = recordUser.data.find(
      (item) => item?.subkategori == subkategoriIndex + 1
    );
    return record ? record : { predikat: "-", skorRentang: "-", koreksi: "-" };
  };

  return (
    <div className="App mt-5">
      <div style={{ overflowX: "auto" }}>
        <Table bordered>
          <thead>
            <tr>
              <th
                rowSpan="2"
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                Kategori
              </th>
              <th
                rowSpan="2"
                className="px-5"
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                Subkategori
              </th>
              {latestAssessments
                .filter(
                  (assessment) => assessment.unit_kerja === selectedAssessedBy
                )
                .map((assessment) => {
                  // <th
                  //   key={`${assessment.unit_kerja}-${assessment.assessed_by}`}
                  //   colSpan="2"
                  //   style={{ textAlign: "center", verticalAlign: "middle" }}
                  // >
                  //   {assessment.assessed_by}
                  // </th>
                  return (
                    <>
                      <th
                        key={`${assessment.unit_kerja}-${assessment.assessed_by}`}
                        colSpan="2"
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        Anonymous
                      </th>
                    </>
                  );
                })}
              <th
                rowSpan="2"
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                Total
              </th>
            </tr>
            <tr>
              {latestAssessments
                .filter(
                  (assessment) => assessment.unit_kerja === selectedAssessedBy
                )
                .map((assessment) => (
                  <>
                    <th
                      key={`predikat-${assessment.unit_kerja}-${assessment.assessed_by}`}
                      style={{ textAlign: "center" }}
                    >
                      Skor
                    </th>
                    <th
                      key={`skor-${assessment.unit_kerja}-${assessment.assessed_by}`}
                      style={{ textAlign: "center" }}
                    >
                      Skor (Rentang)
                    </th>
                  </>
                ))}
            </tr>
          </thead>
          <tbody>
            {RekapSubkategoriKelompok.map((subkategori, index) => (
              <tr key={index}>
                {subkategori.kategori !== "" && (
                  <td
                    style={{
                      textAlign: "center",
                      fontSize: "13px",
                    }}
                    rowSpan={subkategori.rowspan}
                  >
                    {subkategori.kategori}
                  </td>
                )}
                <td style={{ fontSize: "13px" }}>{subkategori.subkategori}</td>
                {latestAssessments
                  .filter(
                    (assessment) => assessment.unit_kerja === selectedAssessedBy
                  )
                  .map((assessment) => {
                    const { predikat } = getDataForSubkategori(
                      index,
                      assessment.assessed_by,
                      assessment.unit_kerja
                    );
                    return (
                      <>
                        <td
                          key={`predikat-${index}-${assessment.unit_kerja}-${assessment.assessed_by}`}
                          style={{ textAlign: "center" }}
                        >
                          {getSkor(data.predikat, predikat)}
                        </td>
                        <td
                          key={`skor-${index}-${assessment.unit_kerja}-${assessment.assessed_by}`}
                          style={{ textAlign: "center" }}
                        >
                          {getSkorRentang(data.predikat, predikat)}
                        </td>
                      </>
                    );
                  })}
                <td style={{ textAlign: "center" }}>
                  {latestAssessments.filter(
                    (assessment) => assessment.unit_kerja === selectedAssessedBy
                  ).length > 0
                    ? latestAssessments
                        .filter(
                          (assessment) =>
                            assessment.unit_kerja === selectedAssessedBy
                        )
                        .filter((assessment) => {
                          const { predikat } = getDataForSubkategori(
                            index,
                            assessment.assessed_by,
                            assessment.unit_kerja
                          );
                          return getSkor(data.predikat, predikat) !== 0;
                        }).length !== 0
                      ? (
                          latestAssessments
                            .filter(
                              (assessment) =>
                                assessment.unit_kerja === selectedAssessedBy
                            )
                            .map((assessment, idx) => {
                              const { predikat } = getDataForSubkategori(
                                index,
                                assessment.assessed_by,
                                assessment.unit_kerja
                              );
                              return getSkor(data.predikat, predikat);
                            })
                            .reduce((partialSum, a) => partialSum + a, 0) /
                          latestAssessments
                            .filter(
                              (assessment) =>
                                assessment.unit_kerja === selectedAssessedBy
                            )
                            .filter((assessment) => {
                              const { predikat } = getDataForSubkategori(
                                index,
                                assessment.assessed_by,
                                assessment.unit_kerja
                              );
                              return getSkor(data.predikat, predikat) !== 0;
                            }).length
                        ).toFixed(2)
                      : 0
                    : 0}
                </td>
              </tr>
            ))}

            {/* Displaying latest Kebutuhan Pengembangan */}
            <tr>
              <td colSpan={2} style={{ textAlign: "center" }}>
                Kebutuhan Pengembangan Diri
              </td>
              {latestAssessments
                .filter(
                  (assessment) => assessment.unit_kerja === selectedAssessedBy
                )
                .map((assessment) => (
                  <>
                    <td
                      colSpan={2}
                      key={`kebutuhan-${assessment.unit_kerja}-${assessment.assessed_by}`}
                      style={{ textAlign: "center" }}
                    >
                      {assessment.kebutuhan_pengembangan}
                    </td>
                  </>
                ))}
              <td></td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default RekapNilaiKelompok;
